import { useCallback, useEffect, useState } from 'react';

import useGlobalState from 'actions';
import Page from 'components/Page';
import {
  useRGetApplicationData,
  useRGetSavedApplication,
} from '@repositories/new-application/queries';
import { useSnackbar } from '@new-components/elements';

import Step from './components/application-step';
import { ApplicationForms } from './constants';
import { applicationPageCx, applicationPageContentCx } from './styles';
import { useProfile } from '@hooks/use-profile';

const Application = () => {
  const [, actions] = useGlobalState();
  const { onOpen } = useSnackbar();

  const [step, setStep] = useState(0);
  const [isSyncedStep, setIsSyncedStep] = useState(false);

  const ApplicationForm = ApplicationForms[step];

  const handleGoBack = useCallback(() => {
    setStep((prev) => (prev > 0 ? prev - 1 : prev));
  }, []);

  const { data: profile } = useProfile();

  const {
    data: savedApplicationData,
    isInitialLoading: isLoadingGetSavedApplicationData,
    isPaused: isPausedGetSavedApplicationData,
  } = useRGetSavedApplication({
    enabled: true,
    step: step + 1,
    onSuccess: () => {
      if (
        profile &&
        ![100, 135].includes(profile?.application.applicationStatus)
      ) {
        window.location.replace('/home');
      }
    },
  });

  useRGetApplicationData({
    page: step + 1,
    enabled: step < 3,
    onError: (err) => {
      onOpen({
        message:
          (err.payload?.errors as Array<string>)?.[0] ||
          'Oops, Something went wrong.',
        severity: 'error',
      });
    },
  });

  useEffect(() => {
    if (isLoadingGetSavedApplicationData || isPausedGetSavedApplicationData) {
      actions.openLoadingOverlay();
    } else {
      actions.closeLoadingOverlay();
    }
  }, [
    actions,
    isLoadingGetSavedApplicationData,
    isPausedGetSavedApplicationData,
    profile,
  ]);

  useEffect(() => {
    if (savedApplicationData?.data && !isSyncedStep) {
      setStep(savedApplicationData.data.currentStep - 1);
      setIsSyncedStep(true);
    }
  }, [isSyncedStep, savedApplicationData?.data, step]);

  return (
    <Page
      className={applicationPageCx}
      contentClassName={applicationPageContentCx}
      useHeader
    >
      <Step step={step} onGoBack={handleGoBack} />
      <ApplicationForm setStep={setStep} />
    </Page>
  );
};

export default Application;
